module.exports = __webpack_public_path__ + "img/10_69.71724ab7.png";